// projects/humanresources-personnel/src/assets/i18n/*/hr-per-subexam.json
export class HrPerSubExamKey {
    private static readonly keyPrefix = 'hrPerSubExam';
    public static title = `${HrPerSubExamKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerSubExamKey.keyPrefix}.pageHeader`;
    public static subExamScore = `${HrPerSubExamKey.keyPrefix}.subExamScore`;
    public static subExamTypeId = `${HrPerSubExamKey.keyPrefix}.subExamTypeId`;
    public static examTypeId = `${HrPerSubExamKey.keyPrefix}.examTypeId`;
    public static subExamDate = `${HrPerSubExamKey.keyPrefix}.subExamDate`;
}
